module.exports = __webpack_public_path__ + "static/media/baseline-chevron_right-24px.b6b6c4db.svg";